/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUserDto } from './GetUserDto';
import {
    GetUserDtoFromJSON,
    GetUserDtoFromJSONTyped,
    GetUserDtoToJSON,
} from './GetUserDto';
import type { GetExamDto } from './GetExamDto';
import {
    GetExamDtoFromJSON,
    GetExamDtoFromJSONTyped,
    GetExamDtoToJSON,
} from './GetExamDto';
import type { GetSupportingExaminationDictDto } from './GetSupportingExaminationDictDto';
import {
    GetSupportingExaminationDictDtoFromJSON,
    GetSupportingExaminationDictDtoFromJSONTyped,
    GetSupportingExaminationDictDtoToJSON,
} from './GetSupportingExaminationDictDto';

/**
 * 
 * @export
 * @interface GetSupportingExaminationDto
 */
export interface GetSupportingExaminationDto {
    /**
     * 
     * @type {string}
     * @memberof GetSupportingExaminationDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetSupportingExaminationDto
     */
    lp?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetSupportingExaminationDto
     */
    type?: GetSupportingExaminationDtoTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof GetSupportingExaminationDto
     */
    examKind?: string | null;
    /**
     * 
     * @type {GetSupportingExaminationDictDto}
     * @memberof GetSupportingExaminationDto
     */
    examKindDict?: GetSupportingExaminationDictDto | null;
    /**
     * 
     * @type {Date}
     * @memberof GetSupportingExaminationDto
     */
    referralDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetSupportingExaminationDto
     */
    consultationDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetSupportingExaminationDto
     */
    result?: string | null;
    /**
     * 
     * @type {GetExamDto}
     * @memberof GetSupportingExaminationDto
     */
    exam?: GetExamDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetSupportingExaminationDto
     */
    diagnosis?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSupportingExaminationDto
     */
    purpose?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSupportingExaminationDto
     */
    codeICD?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetSupportingExaminationDto
     */
    printReferral: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSupportingExaminationDto
     */
    withoutSign: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSupportingExaminationDto
     */
    pdfTemplateType?: GetSupportingExaminationDtoPdfTemplateTypeEnum | null;
    /**
     * 
     * @type {GetUserDto}
     * @memberof GetSupportingExaminationDto
     */
    doctor?: GetUserDto | null;
}


/**
 * @export
 */
export const GetSupportingExaminationDtoTypeEnum = {
    helpExam: 'helpExam',
    specialisedConsultation: 'specialisedConsultation'
} as const;
export type GetSupportingExaminationDtoTypeEnum = typeof GetSupportingExaminationDtoTypeEnum[keyof typeof GetSupportingExaminationDtoTypeEnum];

/**
 * @export
 */
export const GetSupportingExaminationDtoPdfTemplateTypeEnum = {
    art_82_ust_1: 'art_82_ust_1',
    art_82_uprzywilejowany: 'art_82_uprzywilejowany',
    art_82_instruktor_egzaminator: 'art_82_instruktor_egzaminator',
    art_39_transport_drogowy: 'art_39_transport_drogowy',
    medycyna_pracy: 'medycyna_pracy',
    karta_badania_psychologicznego: 'karta_badania_psychologicznego',
    karta_broni: 'karta_broni',
    bron_orzeczenie_lekarskie: 'bron_orzeczenie_lekarskie',
    bron_orzeczenie_psychologiczne: 'bron_orzeczenie_psychologiczne',
    bron_karta_badania_psychologicznego: 'bron_karta_badania_psychologicznego',
    karta_badania_profilaktycznego: 'karta_badania_profilaktycznego',
    mp_orzeczenie_lekarskie_43: 'mp_orzeczenie_lekarskie_43',
    mp_orzeczenie_lekarskie_43_ang: 'mp_orzeczenie_lekarskie_43_ang',
    mp_orzeczenie_lekarskie_43_transport: 'mp_orzeczenie_lekarskie_43_transport',
    kierowca_orzeczenie_lekarskie_art_75_uprzywilejowany: 'kierowca_orzeczenie_lekarskie_art_75_uprzywilejowany',
    kierowca_orzeczenie_lekarskie_art_75_reszta: 'kierowca_orzeczenie_lekarskie_art_75_reszta',
    mp_zaswiadczenie_lekarskie_student: 'mp_zaswiadczenie_lekarskie_student',
    orzeczenie_sanitarno_epidemiologiczne: 'orzeczenie_sanitarno_epidemiologiczne',
    karta_badania_kierowcy: 'karta_badania_kierowcy',
    konsultacja_neurologiczna: 'konsultacja_neurologiczna',
    konsultacja_laryngologiczna: 'konsultacja_laryngologiczna',
    konsultacja_okulistyczna: 'konsultacja_okulistyczna',
    konsultacja_psychiatryczna: 'konsultacja_psychiatryczna',
    karta_odpowiedzi: 'karta_odpowiedzi',
    karta_badania_sanitarno_epidemiologicznego: 'karta_badania_sanitarno_epidemiologicznego',
    zaswiadczenie_lekarskie_zdolnosci_do_pracy: 'zaswiadczenie_lekarskie_zdolnosci_do_pracy',
    zaswiadczenie_sportowe: 'zaswiadczenie_sportowe',
    karta_badania_sportowego: 'karta_badania_sportowego',
    orzeczenie_stan_zdrowia_lekarza: 'orzeczenie_stan_zdrowia_lekarza',
    zaswiadczenie_stan_zdrowia_pielegniarka: 'zaswiadczenie_stan_zdrowia_pielegniarka',
    zaswiadczenie_stan_zdrowia_pielegniarka_art31: 'zaswiadczenie_stan_zdrowia_pielegniarka_art31',
    rejestrOrzeczen: 'rejestrOrzeczen',
    rejestrMedycynaPracy: 'rejestrMedycynaPracy',
    rejestrKierowcow: 'rejestrKierowcow',
    rejestrUczniowieStudenci: 'rejestrUczniowieStudenci',
    skierowanie_uczen: 'skierowanie_uczen',
    skierowanie_uczen_sanitarne: 'skierowanie_uczen_sanitarne',
    skierowanie_pracownik: 'skierowanie_pracownik',
    skierowanie_pracownik_sanitarne: 'skierowanie_pracownik_sanitarne',
    wynik_widzenia_zmierzchowego: 'wynik_widzenia_zmierzchowego',
    wybuch_cywilne_orzeczenie_lekarskie: 'wybuch_cywilne_orzeczenie_lekarskie',
    wybuch_cywilne_orzeczenie_psychologiczne: 'wybuch_cywilne_orzeczenie_psychologiczne',
    wybuch_wojsko_orzeczenie_lekarskie: 'wybuch_wojsko_orzeczenie_lekarskie',
    wybuch_wojsko_orzeczenie_psychologiczne: 'wybuch_wojsko_orzeczenie_psychologiczne',
    detektyw_orzeczenie_lekarskie: 'detektyw_orzeczenie_lekarskie',
    detektyw_orzeczenie_psychologiczne: 'detektyw_orzeczenie_psychologiczne',
    zestawienie_orzeczen: 'zestawienie_orzeczen',
    lista_firm: 'lista_firm',
    skierowanie_do_poradni: 'skierowanie_do_poradni',
    strazak_orzeczenie_lekarskie: 'strazak_orzeczenie_lekarskie',
    kierowca_rajdowy_orzeczenie_psychologiczne: 'kierowca_rajdowy_orzeczenie_psychologiczne',
    nauczyciel_poratowanie_zdrowia: 'nauczyciel_poratowanie_zdrowia',
    zaswiadczenie_okulary: 'zaswiadczenie_okulary',
    faktura_pl: 'faktura_pl',
    korekta_pl: 'korekta_pl'
} as const;
export type GetSupportingExaminationDtoPdfTemplateTypeEnum = typeof GetSupportingExaminationDtoPdfTemplateTypeEnum[keyof typeof GetSupportingExaminationDtoPdfTemplateTypeEnum];


/**
 * Check if a given object implements the GetSupportingExaminationDto interface.
 */
export function instanceOfGetSupportingExaminationDto(value: object): value is GetSupportingExaminationDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('printReferral' in value) || value['printReferral'] === undefined) return false;
    if (!('withoutSign' in value) || value['withoutSign'] === undefined) return false;
    return true;
}

export function GetSupportingExaminationDtoFromJSON(json: any): GetSupportingExaminationDto {
    return GetSupportingExaminationDtoFromJSONTyped(json, false);
}

export function GetSupportingExaminationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSupportingExaminationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lp': json['lp'] == null ? undefined : json['lp'],
        'type': json['type'] == null ? undefined : json['type'],
        'examKind': json['examKind'] == null ? undefined : json['examKind'],
        'examKindDict': json['examKindDict'] == null ? undefined : GetSupportingExaminationDictDtoFromJSON(json['examKindDict']),
        'referralDate': json['referralDate'] == null ? undefined : (new Date(json['referralDate'])),
        'consultationDate': json['consultationDate'] == null ? undefined : (new Date(json['consultationDate'])),
        'result': json['result'] == null ? undefined : json['result'],
        'exam': json['exam'] == null ? undefined : GetExamDtoFromJSON(json['exam']),
        'diagnosis': json['diagnosis'] == null ? undefined : json['diagnosis'],
        'purpose': json['purpose'] == null ? undefined : json['purpose'],
        'codeICD': json['codeICD'] == null ? undefined : json['codeICD'],
        'printReferral': json['printReferral'],
        'withoutSign': json['withoutSign'],
        'pdfTemplateType': json['pdfTemplateType'] == null ? undefined : json['pdfTemplateType'],
        'doctor': json['doctor'] == null ? undefined : GetUserDtoFromJSON(json['doctor']),
    };
}

export function GetSupportingExaminationDtoToJSON(value?: GetSupportingExaminationDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'lp': value['lp'],
        'type': value['type'],
        'examKind': value['examKind'],
        'examKindDict': GetSupportingExaminationDictDtoToJSON(value['examKindDict']),
        'referralDate': value['referralDate'] == null ? undefined : ((value['referralDate'] as any).toISOString()),
        'consultationDate': value['consultationDate'] == null ? undefined : ((value['consultationDate'] as any).toISOString()),
        'result': value['result'],
        'exam': GetExamDtoToJSON(value['exam']),
        'diagnosis': value['diagnosis'],
        'purpose': value['purpose'],
        'codeICD': value['codeICD'],
        'printReferral': value['printReferral'],
        'withoutSign': value['withoutSign'],
        'pdfTemplateType': value['pdfTemplateType'],
        'doctor': GetUserDtoToJSON(value['doctor']),
    };
}

